import useAccount from "./useAccount";
import { hasRole } from "@/lib/utils";

export function useAccountRoleCheck() {
  const { account } = useAccount();
  const role = account?.system_role_code;

  const hasAnyRole = (roles: readonly string[]) => hasRole(role, roles);

  return {
    role,
    hasAnyRole,
  };
}
